import { isFiniteNumber, roundTo } from './safeMath';

export const DASH = '—';

type Maybe<T> = T | null | undefined;

const finiteOrNull = (value: Maybe<number>): number | null =>
  isFiniteNumber(value) ? value : null;

export const fmtNumber = (value: Maybe<number>, digits = 1): string => {
  const n = finiteOrNull(value);
  return n === null ? DASH : roundTo(n, digits).toFixed(digits);
};

export const fmtNinku = (value: Maybe<number>): string => fmtNumber(value, 1);

export const fmtPercent = (value: Maybe<number>): string => {
  const n = finiteOrNull(value);
  return n === null ? DASH : `${Math.round(n)}%`;
};

export const fmtHours = (value: Maybe<number>, digits = 1): string => {
  const n = finiteOrNull(value);
  return n === null ? DASH : `${fmtNumber(n, digits)}h`;
};

export const fmtShortage = (value: Maybe<number>): string => {
  const n = finiteOrNull(value);
  if (n === null) return DASH;
  return n > 0 ? `▲${fmtNumber(n, 1)}` : '0';
};

export const fmtSignedNinku = (value: Maybe<number>): string => {
  const n = finiteOrNull(value);
  if (n === null) return DASH;
  return n < 0 ? `▲${fmtNumber(-n, 1)}` : `+${fmtNumber(n, 1)}`;
};

export const fmtManYen = (yen: Maybe<number>): string => {
  const n = finiteOrNull(yen);
  return n === null ? DASH : Math.round(n / 10_000).toLocaleString('ja-JP');
};

export const fmtYears = (value: Maybe<number>): string => {
  const n = finiteOrNull(value);
  return n === null ? DASH : `${Math.round(n)}年`;
};

export const fmtCount = (value: Maybe<number>, unit = ''): string => {
  const n = finiteOrNull(value);
  return n === null ? DASH : `${Math.round(n).toLocaleString('ja-JP')}${unit}`;
};

/** 数量(人工など)。整数はそのまま、小数は小数 1 位まで(精度を作らず、丸めすぎもしない)。 */
export const fmtQuantity = (value: Maybe<number>): string => {
  const n = finiteOrNull(value);
  if (n === null) return DASH;
  return Number.isInteger(n) ? String(n) : fmtNumber(n, 1);
};

export const fmtText = (value: Maybe<string>): string => {
  if (value === null || value === undefined) return DASH;
  return value.trim() === '' ? DASH : value;
};
